import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authSliceKey, AuthState } from './auth-slice.config';

export const selectAuthFeature = createFeatureSelector<AuthState>(authSliceKey);

export const selectAuthToken = createSelector(selectAuthFeature, (state) => state.token);
